import * as React from 'react';
import { AboutSectionWrapper, ContactContentWrapper } from './AboutSectionStyles';
import { language } from './AboutSectionLanguage';
import { AboutMeLayout } from './AboutMe/AboutMeLayout';
import { FancyHeaderLayout } from '../FancyHeader/FancyHeaderLayout';
import { MeritPanelLayout, Props as MeritPanelProps } from '../MeritPanel/MeritPanelLayout';
import { cssVarColors } from '../../Constants';
import { generateContactInfo, Props as ContactInfoProps } from './ContactInformation/helpers/generateContactInfoLines';
import { CvFilterType } from '../../Types/cvFilterType';
import { SchemaType as SkillsSchemaType } from '../../Schema/CVs/default/Skills';
import { SchemaType as TechnologySchemaType } from '../../Schema/CVs/default/Technologies';
import { SchemaType as ContactSchemaType } from '../../Schema/CVs/default/ContactInfo';
import { SchemaType as LanguagesSchemaType } from '../../Schema/CVs/default/Languages';
import { SchemaType as ToolsSchemaType } from '../../Schema/CVs/default/Tools';
import { SchemaType as IdeologiesSchemaType } from '../../Schema/CVs/default/Ideologies';
import { SchemaType as CoreCompetenciesSchemaType } from '../../Schema/CVs/default/Core Competencies';

export type Props = {
	keywords: CvFilterType;
	aboutMeSchemas: {
		skillsSchema: SkillsSchemaType;
		technologySchema: TechnologySchemaType;
		contactSchema: ContactSchemaType;
		toolsSchema: ToolsSchemaType;
		highlightedSchema: LanguagesSchemaType;
		languagesSchema: LanguagesSchemaType;
		ideologiesSchema: IdeologiesSchemaType;
		coreCompetenciesSchema: CoreCompetenciesSchemaType;
	};
};

export const AboutSectionLayout = (props: Props) => {
	const render = () => {
		const skillsProps: MeritPanelProps = {
			title: props.aboutMeSchemas.skillsSchema.title,
			keywords: props.keywords,
			backgroundColor: cssVarColors.surfaceAlternate,
			textColor: '#fff',
			lines: props.aboutMeSchemas.skillsSchema.lines,
		};

		const techProps: MeritPanelProps = {
			title: props.aboutMeSchemas.technologySchema.title,
			keywords: props.keywords,
			backgroundColor: cssVarColors.surfaceAlternate,
			textColor: '#fff',
			lines: props.aboutMeSchemas.technologySchema.lines,
		};

		const toolsProps: MeritPanelProps = {
			title: props.aboutMeSchemas.toolsSchema.title,
			keywords: props.keywords,
			backgroundColor: cssVarColors.surfaceAlternate,
			textColor: '#fff',
			lines: props.aboutMeSchemas.toolsSchema.lines,
		};

		const toolsAndTechProps: MeritPanelProps = {
			title: props.aboutMeSchemas.technologySchema.title,
			keywords: props.keywords,
			backgroundColor: cssVarColors.surfaceAlternate,
			textColor: '#fff',
			lines: [...props.aboutMeSchemas.technologySchema.lines, ...props.aboutMeSchemas.toolsSchema.lines],
		};

		const highlightedProps: MeritPanelProps = {
			title: props.aboutMeSchemas.highlightedSchema.title,
			keywords: props.keywords,
			backgroundColor: cssVarColors.surfaceAlternate,
			textColor: '#fff',
			lines: props.aboutMeSchemas.highlightedSchema.lines,
		};

		const languageProps: MeritPanelProps = {
			title: props.aboutMeSchemas.languagesSchema.title,
			keywords: props.keywords,
			backgroundColor: cssVarColors.surfaceAlternate,
			textColor: '#fff',
			lines: props.aboutMeSchemas.languagesSchema.lines,
		};

		const ideologies: MeritPanelProps = {
			title: props.aboutMeSchemas.ideologiesSchema.title,
			keywords: props.keywords,
			backgroundColor: cssVarColors.surfaceAlternate,
			textColor: '#fff',
			lines: props.aboutMeSchemas.ideologiesSchema.lines,
		};

		const coreCompetencies: MeritPanelProps = {
			title: props.aboutMeSchemas.coreCompetenciesSchema.title,
			keywords: props.keywords,
			backgroundColor: cssVarColors.surfaceAlternate,
			textColor: '#fff',
			lines: props.aboutMeSchemas.coreCompetenciesSchema.lines,
		};

		const contactInfoProps: ContactInfoProps = {
			contactInfoLines: props.aboutMeSchemas.contactSchema.lines,
		};
		const contactJSX = generateContactInfo(contactInfoProps);
		const contactProps: MeritPanelProps = {
			title: null,
			keywords: props.keywords,
			textColor: '#fff',
			backgroundColor: cssVarColors.surfaceAlternate,
			jsx: <ContactContentWrapper>{contactJSX}</ContactContentWrapper>,
		};

		const returnValue = (
			<AboutSectionWrapper>
				<FancyHeaderLayout />
				<MeritPanelLayout {...contactProps} />
				<AboutMeLayout />
				<MeritPanelLayout {...highlightedProps} />
				<MeritPanelLayout {...languageProps} />
				{/*<MeritPanelLayout {...toolsProps} />*/}
				{/*<MeritPanelLayout {...techProps} />*/}
				<MeritPanelLayout {...toolsAndTechProps} />
				<MeritPanelLayout {...skillsProps} />
				<MeritPanelLayout {...coreCompetencies} />
				<MeritPanelLayout {...ideologies} />
			</AboutSectionWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
